import { render, staticRenderFns } from "./AiResponseConfirm.vue?vue&type=template&id=0648c436&"
import script from "./AiResponseConfirm.vue?vue&type=script&lang=ts&"
export * from "./AiResponseConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports